
import { useState ,useEffect} from 'react'
import {useSelector, useDispatch } from 'react-redux';
import { delimei, getDms, resetimei, relocate } from '../../redux/actions';
import { useNavigate } from 'react-router-dom';
import { formatDateTime, checkDeviceLink } from '../Utils/DateFormatter';
import DmLink from '../UI/DmLink/DmLink';
import Modal from '../UI/Modal/Modal';
import Button from '../UI/Button/Button';
import sbros from '../../img/sbros.png'; 
import delet from '../../img/udalit.png';
import relocation from '../../img/hand_over.png';
import magnifier from "../../img/magnifier.svg"
import './ImeiSummary.css';

export default function ImeiSummary({item, users, browserTime}) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userid=useSelector((state) => state.userdata?.id);
    const islink = checkDeviceLink(item?.param_last_date, browserTime) ?  'Online' : 'Offline';

    const [action, setAction] = useState('');
    const [modal, setModal] = useState(false)
    const [inputModal, setInputModal] = useState('');
    const [selectName, setSelectName] = useState ('');

    function onClickWinOpen(value) {
        setAction(value);
        setInputModal('');
        setSelectName('');
        setModal(true);
    }
    async function onClickActionSave(value) {
        let num;
        switch(item?.type) {
            case 'круговая':
                num=6;
                break;
            case 'секторная':
                num=6;//для сброса по умолчанию  
                break;
            case 'RS485':
                num=3;
                break;
            default:
                num=null;
                break;
        }
        setModal(false);
        if (action === 'delet') {await dispatch(delimei(value))}
        else if (action === 'reset') {await dispatch(resetimei(value, userid, num))}
        await dispatch(getDms());
    }

    async function onClickRelocation(imei, newUser) {
        setModal(false);
        await dispatch(relocate(imei,newUser));
        await dispatch(getDms());
    }

    const handleClick = (e) => {
        e.preventDefault();
        navigate(`/device/${item?.imei}`);
      };

      const filteredUsers = users && users.filter(user =>
        inputModal === '' || // Если поисковой запрос пуст, отображаем все элементы
         user.username.toLowerCase().includes(inputModal.toLowerCase()) ||
         user.surname.toLowerCase().includes(inputModal.toLowerCase()) ||
         user.name.toLowerCase().includes(inputModal.toLowerCase()) ||
         user.patronymic.toLowerCase().includes(inputModal.toLowerCase())
      );
    return(
        <>
        <div className='imeiCard'>
            <div className='imeiCardHeader'>
                <strong onClick={handleClick}
                 className={`cardHeaderName ${item?.type==='RS485'? ("type-RS485"):("type-DM")} `}>
                 {item?.imei}</strong>
                <div className='imeiCardHeaderInfo'>
                   <span>{islink==='Offline' && (formatDateTime(item?.param_last_date))}</span>
                    <DmLink islink={islink} />
                </div>
            </div>
            <div className='imeiCardBody'>
                <div className='imeiCardBodyInfo'>
                    <div className='imeiInfoTitle'>
                    Владелец:<span> {item?.username}</span>
                    </div>
                    <div className='imeiInfoTitle'>
                        Тип: <span>{(item?.type==='секторная' || item?.type==='круговая') ?
                        'ДМ' : 'Модем RS485' }</span>
                    </div>
                    <div className='imeiInfoTitle'>
                        Название:<span> {item?.imei_name}</span>
                    </div>
                </div>
                <div className=' imeiCardBodyBtn'>
                    <button onClick={()=>onClickWinOpen('relocation')} className='imeiBtn'>
                        <img src={relocation} alt="Result" /> 
                    </button>
                    <button onClick={()=>onClickWinOpen('reset')} className='imeiBtn'>
                        <img src={sbros} alt="Result" /> 
                    </button>
                    <button onClick={()=>onClickWinOpen('delet')} className='imeiBtn'>
                        <img src={delet} alt="Result" /> 
                    </button>
                </div>
            </div>
        </div>  

        <Modal open={modal}>

                <div className='modalHeader'>
                { action === 'relocation' ? 
                   <div className='relocationModalHeader'>
                        <h3>Перемещение: </h3>  
                    </div>
                   : <h3>Подтвердите действие</h3> }
                    <svg  onClick={()=>setModal(false)} height="30" viewBox="0 0 200 200" width="30">    
                        <path d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z" />
                    </svg> 
                </div>

            { action === 'relocation' && 
                <div className='relocationSelectMain'>
                    <h3>{item?.imei}</h3>
                    <h4>Выберите пользователя:</h4>
                        <div className='relocationSelectUser'> 
                            {filteredUsers.map(user=>
                            <p>
                                <button key={user.id} className = {selectName===user.id ? 'selectUserOn' : 'selectUserOff'}
                                onClick={() => setSelectName(user.id)}>{user.username} </button> - 
                                {user.surname} {user.name} {user.patronymic}
                            </p>
                            )}
                        </div>
                    <div className='relocationUserSearch'> 
                    {inputModal==='' ? (
                    <img src={magnifier} alt="Result" />
                        ) : (
                    <svg  onClick={()=>setInputModal('')} className='UserDeletQuest' height="30" viewBox="0 0 200 200" width="30">    
                        <path d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z" />
                    </svg>
                    )}
                        <input type='text' className='relocationInput' value={inputModal}
                        placeholder='Введите данные пользователя'
                        onChange={e=>setInputModal(e.target.value)} />
                    </div>    
                </div>
           }
             { action !== 'relocation' && <> 
                    <label className='labelInfo'>Вы точно желаете {action==='reset' ? (' сбросить настройки?') : (
                     action==='delet' ? ' удалить IMEI?' : null) } </label>
                         <h4 className='labelInfoQuet'>{item?.imei}</h4>
                </>
                }
            <div className='contentControl'>
            { action === 'relocation' && <h4 className='relocationConfirm'>Подтвердите выбор</h4>}
                <div className='modalButton' >
                    <Button onClick={() => setModal(false)} color="#d2e9d2">Отмена</Button>
                    { action === 'relocation' ?  
                    <Button onClick={()=> onClickRelocation(item?.imei, selectName)} color="#4bdd4b">Передать</Button>:  
                    <Button onClick={()=> onClickActionSave(item?.imei)} color="#4bdd4b">Да</Button>}
                </div>
            </div>
        </Modal>
    </>
    )
}